const initState={
    
   menuShow:false,
    
}



function commonInfo(state = initState, action) {
    switch (action.type) {
      case 'COMMON_SET_MENUSHOW'://for login by email - OTP
         return {...state,menuShow:action.payload}
      
     
      default:
        return state
    }
  }

export default commonInfo;